import RoutePathEnum from "../enums/RoutePathEnum";
import Login from "../old/pages/Login";
import FederatedTokenLogin from "../old/pages/FederatedTokenLogin";
import LoginDashboard from "../old/pages/LoginDashboard";
import ForgotPassword from "../old/pages/ForgotPassword";
import ForgotPasswordFinish from "../new/pages/ResetPassword/ForgotPasswordFinish";
import AccountConflict from "../old/pages/AccountConflict";
import LoginDashboardPopup from "../old/pages/LoginDashboardPopup";
import AccountUnification from "../old/pages/AccountUnification";
import Dashboard from "../new/pages/Dashboard";
import Users from "../new/pages/Users/Users";
import UserUpdate from "../new/pages/Users/UserUpdate";
import ChangePassword from "../new/pages/ResetPassword/ChangePassword";
import UserDeleted from "../new/pages/Deleted/Users/UserDeleted";
import OrganizationDeleted from "../new/pages/Deleted/Organizations/OrganizationDeleted";
import Resellers from "../new/pages/Resellers/Resellers";
import ResellerCreate from "../new/pages/Resellers/ResellerCreate";
import OrganizationCreate from '../new/pages/Organizations/OrganizationCreate'
import Organizations from "../new/pages/Organizations/Organizations";
import MaintenanceMode from "@/new/pages/SystemSettings/MaintenanceMode";
import MaintenanceModeDashboard from "@/new/pages/SystemSettings/MaintenanceModeDashboard";
import axios from 'axios';
import store from "../store";

import AuthService from "../new/services/AuthService";
import OrganizationLogin from "@/new/pages/OrganizationLogin/Login";
import OrganizationForgotPassword from "@/new/pages/OrganizationLogin/ForgotPassword";
import colorHelper from "@/js/colorHelper";
import FederatedEmailLogin from "../old/pages/FederatedEmailLogin";
import Security from "../new/pages/Security";

function handleCustomOrganizationPage(to, from, next) {
    if (AuthService.isLogged()) {
        if (AuthService.handleAlreadyAuthenticatedSession()) {
            return;
        }

        next(RoutePathEnum.DASHBOARD)
        return;
    }
    let url = process.env.VUE_APP_API_URL + '/custom-login-page/' + to.params.organization;
    axios.get(url)
        .then(response => {
            response = response.response
            if (response.status === 200) {
                store.commit('loginPage/setData', response.data.data);
                if (response.data.data.color) {
                    colorHelper.setDocumentAccentColor(response.data.data.color)
                }
                next();
            } else {
                next(RoutePathEnum.LOGIN);
            }
        })
        .catch(() => {
            next(RoutePathEnum.LOGIN);
        });
    next();
}

function getRoutesPath() {

    let routes = [
        /** Old pages **/
        {
            path: RoutePathEnum.LOGIN,
            component: Login,
            meta: { title: 'Login' },
            // Before we open default login page we need to reset custom organization colors. Because when we logout from SPA we redirect to default login page.
            beforeEnter: (to, from, next) => {
                colorHelper.resetColors();
                next();
            }
        },
        {
            path: RoutePathEnum.FEDERATED_TOKEN_LOGIN,
            component: FederatedTokenLogin,
            meta: { title: 'Sign in' },
        },
        {
            path: RoutePathEnum.FEDERATED_EMAIL_LOGIN,
            component: FederatedEmailLogin,
            meta: { title: 'SSO sign in' },
        },
        {path: RoutePathEnum.LOGIN_DASHBOARD_POPUP, component: LoginDashboardPopup, meta: { title: 'Sign in' }},
        {path: RoutePathEnum.FORGOT_PASSWORD, component: ForgotPassword, meta: { title: 'Forgot password' }},
        {path: RoutePathEnum.ACCOUNT_CONFLICT, component: AccountConflict, meta: { title: 'Account conflict' }},
        {path: RoutePathEnum.FORGOT_PASSWORD_FINISH, component: ForgotPasswordFinish, meta: { title: 'Reset password' }},
        {path: RoutePathEnum.LOGIN_DASHBOARD, component: LoginDashboard, meta: { title: 'Sign in' }},
        {path: RoutePathEnum.ACCOUNT_UNIFICATION, component: AccountUnification, meta: { title: 'Account unification' }},

        {path: RoutePathEnum.MAINTENANCE_MODE_DASHBOARD, component: MaintenanceModeDashboard, meta: { title: 'Maintenance mode' }},

        /** New pages **/
        {path: RoutePathEnum.DASHBOARD, component: Dashboard, meta: { title: 'Dashboard' }},
        {path: RoutePathEnum.USERS, component: Users, meta: { title: 'Users' }},
        {path: RoutePathEnum.DELETED_USERS, component: UserDeleted, meta: { title: 'Deleted users' }},
        {path: RoutePathEnum.USER_UPDATE, component: UserUpdate, meta: { title: 'User', dynamicEntityTitle: true }},
        {path: RoutePathEnum.CHANGE_PASSWORD, component: ChangePassword, meta: { title: 'Change password' }},

        {path: RoutePathEnum.MAINTENANCE_MODE, component: MaintenanceMode, meta: { title: 'Maintenance mode' }},
    ];

    if (process.env.VUE_APP_FEATURE_AVALIABLE_RESELLERS === 'true') {
        routes.push({path: RoutePathEnum.RESELLERS, component: Resellers, meta: { title: 'Resellers' }});
        routes.push({path: RoutePathEnum.RESELLER_UPDATE, component: ResellerCreate, meta: { title: 'Reseller', dynamicEntityTitle: true }});
        routes.push({path: RoutePathEnum.RESELLERS_CREATE, component: ResellerCreate, meta: { title: 'Create reseller' }});
    }
    if (process.env.VUE_APP_FEATURE_AVALIABLE_ORGANIZATIONS === 'true') {
        routes.push({path: RoutePathEnum.ORGANIZATIONS, component: Organizations, meta: { title: 'Organizations' }});
        routes.push({path: RoutePathEnum.DELETED_ORGANIZATIONS, component: OrganizationDeleted, meta: { title: 'Deleted organizations' }});
        routes.push({path: RoutePathEnum.ORGANIZATION_CREATE, component: OrganizationCreate, meta: { title: 'Create organization' }});
        routes.push({path: RoutePathEnum.ORGANIZATION_UPDATE, component: OrganizationCreate, meta: { title: 'Organization', dynamicEntityTitle: true }});
    }


    routes.push({
        path: RoutePathEnum.SECURITY,
        component: Security,
        name: 'SECURITY',
        meta: { title: 'Security' },
        beforeEnter: (to, from, next) => {
            if (AuthService.isLogged()) {
                next();
            } else {
                next(RoutePathEnum.LOGIN);
            }
        }
    })

    routes.push({
        path: RoutePathEnum.CUSTOM_LOGIN,
        component: OrganizationLogin,
        name: 'CustomOrganizationLoginPage',
        meta: { title: 'Sign in' },
        beforeEnter: (to, from, next) => {
            handleCustomOrganizationPage(to, from, next)
        }
    })
    routes.push({
        path: RoutePathEnum.CUSTOM_FORGOT_PASSWORD,
        component: OrganizationForgotPassword,
        name: 'CustomOrganizationForgotPassword',
        meta: { title: 'Forgot password' },
        beforeEnter: (to, from, next) => {
            handleCustomOrganizationPage(to, from, next)
        }
    })


    return routes;
}

export default getRoutesPath()
